import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DevicesRouterStoreSelectors } from '@era/stores';
import { DeviceTask } from '@rocksoft/device-task-management-sdk';
import * as fromScheduledTasks from './device-scheduled-tasks.reducer';
import { DeviceScheduledTasksState } from './device-scheduled-tasks.state';

export const selectScheduledTasksState = createFeatureSelector<DeviceScheduledTasksState>('deviceScheduledTasks');

export const selectScheduledTasks = createSelector(
  selectScheduledTasksState,
  fromScheduledTasks.selectAllDeviceScheduledTasks
);

export const selectScheduledTasksByUdid = createSelector(
  selectScheduledTasks,
  DevicesRouterStoreSelectors.selectUdid,
  (scheduledTasks: DeviceTask[], udid: string) => scheduledTasks.filter((x) => x.udid === udid)
);
